export const pickOperations = (value: any[], formatMessage: any) => {
    const operationsChart: any = {
        view: {
            "icon": ["open-eyes", 'closed-eyes'],
            "value": "view",
            "tip": formatMessage({ id: 'dbs_view' }),
            'isNoSelect': true,
            format: true,
        },
        pie: {
            "icon": "pie-chart-icon",
            "value": "pie",
            "tip": "Pie Chart"
        },
        table: {
            "icon": "sheet",
            "value": "table",
            "tip": formatMessage({ id: 'dbs_table' }),
        },
        line: {
            "icon": "discount-chart",
            "value": "line",
            "tip": formatMessage({ id: 'dbs_line_chart' }),
        },
        linearea: {
            "icon": "discount-chart-area",
            "value": "line",
            "tip": formatMessage({ id: 'dbs_line_chart' }),
        },
        'stack_line': {
            "icon": "stack-diagram",
            "value": "stack_line",
            "tip": "Stacked Chart"
            // "tip": formatMessage({ id: 'dbs_line_chart' }),
        },
        bar: {
            "icon": "column-chart",
            "value": "bar",
            "tip": formatMessage({ id: 'dbs_bar_chart' }),
        },
        download: {
            "icon": "download",
            "value": "download",
            "tip": formatMessage({ id: 'dbs_download' }),
            'isNoSelect': true
        }
    };
    const data: any = [];
    value.forEach((item: string) => {
        operationsChart[item] && data.push(operationsChart[item]);
    });
    return data;
};